import { postForm, ENDPOINTS } from "../../../services/checkout";

const requestTempToken = ({ errors, values }) => {
  if (Object.keys(errors).length === 0) {
    postForm({
      endpoint: ENDPOINTS.SHOPIFY_AUTHORIZE,
      body: values,
      withRedirect: true,
    });
  }
};

export default requestTempToken;
